// extracted by mini-css-extract-plugin
export default {"modal":"AuthModal_modal__NG8DJ","header":"AuthModal_header__EWasW","logo":"AuthModal_logo__NUV4m","btnBack":"AuthModal_btnBack__8Rwiz"};